import { forwardRef } from "react";

import { tw } from "~/utils";

export const TableCell = forwardRef<
  HTMLTableCellElement,
  React.TdHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => (
  <td
    ref={ref}
    className={tw("text-dark-blue-gray w-fit p-3 text-lg", className)}
    {...props}
  />
));
TableCell.displayName = "TableCell";
